import React, { Component } from 'react'
import { connect } from 'react-redux'
import css from './styles.scss'

export class RoundEditor extends Component {
  acceptableMacros = ['javascript', 'choiceFromReference', 'choiceFromAnonymous', 'randomNumber', 'number', 'getter', 'formula', 'round'];
  roundingMethods = [
    <option value='' key='_EMPTY_OPTION_'>Select a rounding method</option>,
    <optgroup label='Decimal' key='Decimal'>
      <option value={0.001} key='Thousandth'>Thousandth</option>
      <option value={0.01} key='Hundredth'>Hundredth</option>
      <option value={0.1} key='Tenth'>Tenth</option>
    </optgroup>,
    <optgroup label='Integer' key='Integer'>
      <option value={1} key='Whole'>Whole</option>
      <option value={5} key='Five'>Five</option>
      <option value={10} key='Ten'>Ten</option>
      <option value={50} key='Fifty'>Fifty</option>
      <option value={100} key='Hundred'>Hundred</option>
      <option value={500} key='Five Hundred'>Five Hundred</option>
      <option value={1000} key='Thousand'>Thousand</option>
      <option value={1000000} key='Million'>Million</option>
    </optgroup>
  ];

  constructor ({ variable }) {
    super()
    this.state = {
      reference: variable.args[0] || '',
      roundAmt: variable.args[1] || 1
    }
  }

  componentWillReceiveProps (nextProps) {
    const { report, save, variableName } = this.props
    const { reference, roundAmt } = this.state
    if (nextProps.report === true && report === false) {
      save(variableName, [reference, roundAmt])
    }
  }

  componentDidUpdate (prevProps, prevState) {
    const { update } = this.props
    if (prevState !== this.state) {
      update()
    }
  }

  handleUpdateReference = evt => {
    this.setState({
      reference: evt.target.value
    })
  }

  handleUpdateRounding = evt => {
    this.setState({
      roundAmt: evt.target.value
    })
  }

  render () {
    const { variableName, vars } = this.props
    const { reference, roundAmt } = this.state
    const varList = [<option value='' key='_EMPTY_OPTION_'>Select a variable</option>]
    Object.keys(vars).forEach(varName => {
      if (variableName !== varName) {
        const varDeets = vars[varName]
        if (this.acceptableMacros.indexOf(varDeets.macro) > -1) {
          varList.push(
            <option value={varName} key={varName}>{varDeets.name}</option>
          )
        }
      }
    })
    return (
      <div>
        <div className={css.choice}>
          <label>Reference Variable</label>
          <div className={css.backer}>
            <select
              className={css.select}
              value={reference}
              onChange={this.handleUpdateReference}
            >
              {varList}
            </select>
          </div>
        </div>
        <div className={css.choice}>
          <label>Rounding Method</label>
          <div className={css.backer}>
            <select
              className={css.select}
              value={roundAmt}
              onChange={this.handleUpdateRounding}
            >
              {this.roundingMethods}
            </select>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  const { app } = state
  return {
    app
  }
}

export default connect(mapStateToProps)(RoundEditor)



// WEBPACK FOOTER //
// /app/js/components/EditVariable/RoundEditor/index.js